import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import moment from 'moment';
import { Link, browserHistory } from 'react-router';
import { initialize, reduxForm, Field } from 'redux-form';
import { getFBAdPreview, submitAd, uploadBase64Image, uploadImages, uploadVideo, createPageLikeAd, createWebsiteClickAd, parseLink, fetchExistingForms, clearAdBuilderForOrg, changeAdBuilderValue } from 'redux/modules/adBuilder';
import { generateSlideshowVideo, uploadVideoToFacebook } from 'redux/modules/ads';
import { getSocialAccounts } from 'redux/modules/organization';
import { LLTextField, LLCheckbox, LLTextArea, LLDropDownList } from '../../components/FormElements';
import { ImageUploadSection, VideoUploadSection, CarouselItemUploadSection } from 'components/AdBuilder';
import { ButtonBar, FacebookCTASelector, FormSection, GrayButton, IframePreview, LoaderBar, MiniTabBar, PageHeader, Spinner, SecondaryButton } from 'components';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { Cropper } from 'react-image-cropper';
import { FBDesktopPreview, FBRightPreview, FBMobilePreview, InstagramPreview } from '../../components/AdBuilder/Previews';
import * as styles from './AdBuilder.scss';
import { generateFacebookTargetingSpec } from '../../helpers/facebookAdTargeting';
import io from 'socket.io-client';
import adBlocker from 'just-detect-adblock';
var AdStep3 = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var formName = "adForm_".concat(orgId);
  return {
    isLikeableUser: state.config.userType.isLikeableUser,
    slideshowUploadKey: state.ads.slideshowUploadKey,
    adDetails: state.adBuilder["".concat(orgId)],
    formValues: _objectSpread({}, state.adBuilder["".concat(orgId)]),
    type: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    orgAdBuilder: state.adBuilder["".concat(orgId)],
    adImage: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adImage : [],
    parsedLinkData: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].parsedLinkData : null,
    organization: state.organization.current,
    DESKTOP_FEED_STANDARD: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].DESKTOP_FEED_STANDARD : null,
    MOBILE_FEED_STANDARD: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].MOBILE_FEED_STANDARD : null,
    RIGHT_COLUMN_STANDARD: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].RIGHT_COLUMN_STANDARD : null,
    loadingFBAdPreview: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].loadingFBAdPreview : false,
    slideshowVideoID: state.ads.slideshowVideoID,
    facebookAdAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    config: state.config,
    theme: state.theme,
    uploadingBase64Image: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].uploadingBase64Image : false,
    uploadedFacebookVideo: state.ads.uploadedFacebookVideo,
    uploadingFile: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].uploadingFile : false,
    isUploadingFacebookVideo: state.ads.isUploadingFacebookVideo,
    exampleLeadFormId: state.adBuilder["leadBuilder_".concat(orgId)] && state.adBuilder["leadBuilder_".concat(orgId)].existingForms && state.adBuilder["leadBuilder_".concat(orgId)].existingForms.length ? state.adBuilder["leadBuilder_".concat(orgId)].existingForms[0].id : null,
    fbAdPreviewError: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].fbAdPreviewError : null,
    adAccountConnectedInstagramId: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].adAccountConnectedInstagramId : null,
    savedAudiences: state.ads.savedAudiences,
    saveError: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].saveError : null
  };
}, {
  initialize: initialize,
  generateSlideshowVideo: generateSlideshowVideo,
  getFBAdPreview: getFBAdPreview,
  uploadBase64Image: uploadBase64Image,
  uploadImages: uploadImages,
  uploadVideo: uploadVideo,
  createPageLikeAd: createPageLikeAd,
  getSocialAccounts: getSocialAccounts,
  parseLink: parseLink,
  createWebsiteClickAd: createWebsiteClickAd,
  uploadVideoToFacebook: uploadVideoToFacebook,
  fetchExistingForms: fetchExistingForms,
  clearAdBuilderForOrg: clearAdBuilderForOrg,
  changeAdBuilderValue: changeAdBuilderValue
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdStep3, _Component);

  var _super = _createSuper(AdStep3);

  function AdStep3(_props) {
    var _this;

    _classCallCheck(this, AdStep3);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "canContinue", function () {
      var adDetails = _this.props.adDetails;

      if (_this.props.type !== 'leadGeneration' && _this.state.isCreating) {
        return false;
      }

      var adFormat = _this.props.formValues.adFormatTabKey;

      if (!adFormat) {
        return false;
      }

      if (adFormat.key === 'image') {
        if (!adDetails['image-ad-upload']) {
          return false;
        }
      } else if (adFormat.key === 'video') {
        if (!adDetails['video-ad-upload'] || !adDetails['video-ad-upload'].length) {
          return false;
        }
      } else if (adFormat.key === 'carousel') {
        if (!adDetails['carousel-ad-upload']) {
          return false;
        }
      }

      return !!adDetails.description;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.getFBAdPreview();

      _this.websocket.on('video_did_process', _this.handleVideoProcessed);

      _this.props.getSocialAccounts(_this.props.organization.id); // clicksToWebsite = 1.9:1 EXAMPLE = 1200x628
      // pageLikes ratio = 2.7:1 EXAMPLE = 1200x444
      // state starts assuming pageLike ad image size


      if (_this.props.type === 'clicksToWebsite') {
        _this.setState({
          imageHeight: 628,
          imageRatio: 1200 / 628
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "socketConfig", function (path) {
      var location = '';

      if (_this.props.config.appEnv === 'production') {
        location = 'https://api-prod.likeablelocal.com';
      } else if (_this.props.config.appEnv === 'demo') {
        location = 'https://api-prod.likeabledemos.com';
      }

      return {
        location: location,
        config: {
          path: path,
          autoConnect: true
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "websocket", io(_this.socketConfig('/ws').location, _objectSpread({}, _this.socketConfig('/ws').config)));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.fbAdPreviewError && _this.state.fbAdPreviewRendering) {
        setTimeout(function () {
          _this.setState({
            fbAdPreviewRendering: false
          });
        }, 200);
      }

      if (!_this.props.uploadedFacebookVideo && nextProps.uploadedFacebookVideo) {
        setTimeout(function () {
          _this.getFBAdPreview();
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFBAdPreview", function (changedAdDetails) {
      setTimeout(function () {
        return _this.setState({
          fbAdPreviewRendering: true
        });
      }, 50);
      var platformId = _this.props.facebookAdAccount.facebookPageId;
      var fbAcctId = _this.props.facebookAdAccount.socialAccountId;
      var adDetails = changedAdDetails || _this.props.adDetails;
      var slideshowUrls = ['https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg', 'https://likeabucket.s3.amazonaws.com/user_upload/216/HkJzsecD-.png'];
      var imageUrl = _this.props.formValues.adImage && _this.props.formValues.adImage.length ? _this.props.formValues.adImage[0] : 'https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg';

      if (adDetails && adDetails.hasOwnProperty('image-ad-upload')) {
        if (adDetails['image-ad-upload'].length) {
          if (typeof adDetails['image-ad-upload'][0] === 'string') {
            imageUrl = adDetails['image-ad-upload'][0];
          }
        }
      }

      if (adDetails && adDetails.hasOwnProperty('carousel-ad-upload')) {
        if (adDetails['carousel-ad-upload'].length) {
          var duration_ms = adDetails['slideshow-duration'] ? adDetails['slideshow-duration'].val : 2000;
          var transition_ms = adDetails['slideshow-transition'] ? adDetails['slideshow-transition'].val : 500;
          slideshowUrls = adDetails['carousel-ad-upload'];
          var slideshowKey = "".concat(slideshowUrls.join('')).concat(duration_ms).concat(transition_ms);

          if (_this.props.slideshowUploadKey !== slideshowKey) {
            console.log('get new slideshow preview');

            _this.props.generateSlideshowVideo(_this.props.organization.id, fbAcctId, slideshowUrls, duration_ms, transition_ms).then(function () {
              setTimeout(function () {
                _this.throttleAdPreview(_this.props.adDetails);
              }, 300);
            });
          }
        }
      }

      var imagePreviewPayload;

      if (_this.props.type === 'pageLikes') {
        imagePreviewPayload = {
          creativeSpec: {
            object_story_spec: {
              link_data: {
                call_to_action: {
                  type: 'LIKE_PAGE',
                  value: {
                    page: platformId
                  }
                },
                link: "https://facebook.com/".concat(platformId),
                image_url: imageUrl,
                name: _this.props.formValues.linkHeadline,
                message: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.'
              },
              page_id: platformId
            }
          }
        };
      } else if (_this.props.type === 'clicksToWebsite') {
        imagePreviewPayload = {
          adType: _this.state.selectedPreviewTab,
          creativeSpec: {
            object_story_spec: {
              link_data: {
                call_to_action: {
                  type: adDetails.call_to_action,
                  value: {
                    link: adDetails.linkUrl
                  }
                },
                link: adDetails.linkUrl,
                image_url: imageUrl,
                caption: function () {
                  try {
                    return new URL(adDetails.linkUrl).hostname;
                  } catch (e) {
                    return undefined;
                  }
                }(),
                description: _this.props.formValues.linkDescription,
                name: _this.props.formValues.linkHeadline,
                message: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.'
              },
              page_id: platformId
            }
          }
        };
      } else {
        imagePreviewPayload = {
          adType: _this.state.selectedPreviewTab,
          creativeSpec: {
            object_id: platformId,
            image_url: imageUrl,
            body: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.'
          }
        };
      }

      var payload = imagePreviewPayload;

      if (_this.props.type === 'leadGeneration') {
        payload = {
          adType: _this.state.selectedPreviewTab,
          creativeSpec: {
            object_story_spec: {
              link_data: {
                call_to_action: {
                  type: adDetails.call_to_action,
                  value: {
                    lead_gen_form_id: _this.props.exampleLeadFormId
                  }
                },
                name: _this.props.formValues.linkHeadline,
                description: _this.props.formValues.leadFormDescription,
                link: 'http://fb.me/',
                image_url: imageUrl,
                message: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.'
              },
              page_id: platformId
            }
          }
        };
        console.dir(payload);
      }

      if (adDetails.adFormatTabKey === 'carousel') {
        var videoUrl = adDetails['video-ad-upload'] && adDetails['video-ad-upload'].length ? adDetails['video-ad-upload'][0] : null;

        var _imageUrl = videoUrl ? videoUrl.replace('.mp4', '.jpg') : null;

        payload = {
          adType: _this.state.selectedPreviewTab,
          creativeSpec: {
            object_story_spec: {
              video_data: {
                image_url: _this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoStill : _this.props.formValues.videoData && _this.props.formValues.videoData.image_url ? _this.props.formValues.videoData.image_url : slideshowUrls && slideshowUrls.length ? slideshowUrls[0] : _imageUrl,
                message: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.',
                video_id: _this.props.slideshowVideoID ? _this.props.slideshowVideoID.id : _this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoId : _this.props.formValues.videoData && _this.props.formValues.videoData.video_id ? _this.props.formValues.videoData.video_id : null
              },
              page_id: platformId
            }
          }
        };
      } else if (adDetails.adFormatTabKey === 'video') {
        var _videoUrl = adDetails['video-ad-upload'] && adDetails['video-ad-upload'].length ? adDetails['video-ad-upload'][0] : null;

        var _imageUrl2 = _videoUrl ? _videoUrl.replace('.mp4', '.jpg') : null;

        payload = {
          adType: _this.state.selectedPreviewTab,
          creativeSpec: {
            object_story_spec: {
              video_data: _objectSpread({
                image_url: _this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoStill : _this.props.formValues.videoData && _this.props.formValues.videoData.image_url ? _this.props.formValues.videoData.image_url : slideshowUrls && slideshowUrls.length ? slideshowUrls[0] : _imageUrl2,
                message: adDetails && adDetails.hasOwnProperty('description') ? adDetails.description : 'Create, curate and automatically post engaging content to your Facebook, Twitter and LinkedIn accounts.',
                video_id: _this.props.slideshowVideoID ? _this.props.slideshowVideoID.id : _this.props.uploadedFacebookVideo ? _this.props.uploadedFacebookVideo.videoId : _this.props.formValues.videoData && _this.props.formValues.videoData.video_id ? _this.props.formValues.videoData.video_id : null
              }, _this.props.type === 'pageLikes' ? {
                call_to_action: {
                  type: 'LIKE_PAGE',
                  value: {
                    page: platformId
                  }
                }
              } : {}),
              page_id: platformId
            }
          }
        };
      }

      console.dir(payload);

      _this.props.getFBAdPreview(_this.props.organization.id, fbAcctId, _this.state.selectedPreviewTab, payload);
    });

    _defineProperty(_assertThisInitialized(_this), "throttleAdPreview", _.debounce(function (details) {
      _this.getFBAdPreview(details);
    }, 1000));

    _defineProperty(_assertThisInitialized(_this), "handleNext", function () {
      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/create-ad/4")
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleVideoProcessed", function (data) {
      var orgId = _this.props.organization.id;
      console.log('handleVideoProcessed');
      console.dir(data);

      if (_this.props.formValues['video-ad-upload'] && _this.props.formValues['video-ad-upload'].length && _this.props.formValues['video-ad-upload'][0] === data.old_url) {
        // swapping urls
        _this.props.changeAdBuilderValue(orgId, {
          'video-ad-upload': [data.new_url]
        });

        _this.props.uploadVideoToFacebook(_this.props.organization.id, _this.props.facebookAdAccount.socialAccountId, data.new_url); //      this.setState({ uploadedVideos: [data.new_url] });

      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePreviewTabChange", function (selectedPreviewTab) {
      var tabCopy = [].concat(_this.state.adPreviewTabs);
      tabCopy.forEach(function (tab) {
        tab.selected = tab.key === selectedPreviewTab.key;
      });
      var previewKeyName = selectedPreviewTab.key;

      _this.setState({
        adPreviewTabs: tabCopy,
        selectedPreviewTab: previewKeyName,
        fbAdPreviewRendering: true
      }, function () {
        if (!_this.props.orgAdBuilder[_this.state.selectedPreviewTab]) {
          _this.getFBAdPreview();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "tabChange", function (tab) {
      var _this$setState;

      var tabCopy = [].concat(_this.state["".concat(tab.group, "Tabs")]);
      tabCopy.forEach(function (t) {
        t.selected = t.key === tab.key;
      });
      var orgId = _this.props.organization.id;

      _this.props.changeAdBuilderValue(orgId, {
        adFormatTabKey: tab.key
      });

      _this.setState((_this$setState = {}, _defineProperty(_this$setState, "".concat(tab.group, "Type"), tab.key), _defineProperty(_this$setState, "".concat(tab.group, "Tabs"), tabCopy), _this$setState));
    });

    _defineProperty(_assertThisInitialized(_this), "handleFieldChange", function (fieldName, newValue) {//    this.throttleAdPreview(fieldName, newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCarouselSettings", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.carouselSettingsWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.carouselSettingsLabel
      }, "Duration:"), /*#__PURE__*/React.createElement(LLDropDownList, {
        name: "slideshow-duration",
        type: "dropdown",
        label: "Duration",
        className: "form-control",
        style: {
          width: '100%'
        },
        value: _this.props.formValues['slideshow-duration'],
        onChange: function onChange(val) {
          _this.props.changeAdBuilderValue(_this.props.organization.id, {
            'slideshow-duration': val
          });

          _this.throttleAdPreview(_this.props.adDetails);
        },
        items: [{
          id: 0,
          title: '0.5 second',
          val: 500
        }, {
          id: 1,
          title: '1 second',
          val: 1000
        }, {
          id: 2,
          title: '2 seconds',
          val: 2000
        }, {
          id: 3,
          title: '3 seconds',
          val: 3000
        }, {
          id: 4,
          title: '4 seconds',
          val: 4000
        }, {
          id: 5,
          title: '5 seconds',
          val: 5000
        }]
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.carouselSettingsWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.carouselSettingsLabel
      }, "Transition:"), /*#__PURE__*/React.createElement(LLDropDownList, {
        name: "slideshow-transition",
        type: "dropdown",
        label: "Transition",
        className: "form-control",
        style: {
          width: '100%'
        },
        value: _this.props.formValues['slideshow-transition'],
        onChange: function onChange(val) {
          _this.props.changeAdBuilderValue(_this.props.organization.id, {
            'slideshow-transition': val
          });

          _this.throttleAdPreview(_this.props.adDetails);
        },
        items: [{
          id: 0,
          title: 'None',
          val: 0
        }, {
          id: 1,
          title: 'Fast',
          val: 100
        }, {
          id: 2,
          title: 'Slow',
          val: 500
        }]
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "handleVideoUpload", function (urls) {
      _this.props.changeAdBuilderValue(_this.props.organization.id, {
        'video-ad-upload': urls
      });

      _this.props.uploadVideoToFacebook(_this.props.organization.id, _this.props.facebookAdAccount.socialAccountId, urls[0]);
    });

    _defineProperty(_assertThisInitialized(_this), "renderImageArea", function (key) {
      if (!key) {
        key = 'image';
      }

      var type = _.find(_this.state.formatTabs, function (o) {
        return o.key === key;
      });

      var multiple = type.key === 'carousel';
      var video = type.key === 'video';
      var dropzoneComponent;

      if (_this.props.uploadingFile) {
        dropzoneComponent = function dropzoneComponent() {
          return /*#__PURE__*/React.createElement(Spinner, null);
        };
      } else {
        switch (type.key) {
          case 'image':
            dropzoneComponent = function dropzoneComponent(props) {
              return /*#__PURE__*/React.createElement(ImageUploadSection, props);
            };

            break;

          case 'video':
            dropzoneComponent = function dropzoneComponent(props) {
              return /*#__PURE__*/React.createElement(VideoUploadSection, _extends({}, props, {
                onUpload: _this.handleVideoUpload
              }));
            };

            break;

          case 'carousel':
            dropzoneComponent = function dropzoneComponent(props) {
              return /*#__PURE__*/React.createElement(CarouselItemUploadSection, props);
            };

            break;

          default:
            dropzoneComponent = function dropzoneComponent() {
              return '';
            };

        }
      }

      if (_this.props.adDetails.hasOwnProperty('image-ad-upload') && _this.props.adDetails['image-ad-upload'].length) {
        var newImg = new Image();

        newImg.onLoad = function () {
          var height = newImg.height;
          var width = newImg.width;
          alert("the image size is ".concat(width, "x").concat(height));
        };

        newImg.src = "".concat(_this.props.adDetails['image-ad-upload'][0], "?v=").concat(_this.getRandomNum());
      }

      return /*#__PURE__*/React.createElement(FormSection, {
        title: type.title,
        style: {
          position: 'relative',
          flexDirection: 'column'
        }
      }, type.key === 'carousel' && _this.renderCarouselSettings(), type.key === 'image' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageUploadSection, {
        name: "".concat(key, "-ad-upload"),
        organization: _this.props.organization,
        height: _this.state.imageHeight / 4,
        width: _this.state.imageWidth / 4,
        multiple: multiple,
        video: video,
        onChange: function onChange(mediaArray) {
          _this.props.changeAdBuilderValue(_this.props.organization.id, _defineProperty({}, "".concat(key, "-ad-upload"), mediaArray));

          _this.throttleAdPreview(_this.props.adDetails);
        }
      }), _this.props.adDetails.hasOwnProperty('image-ad-upload') && !!_this.props.adDetails['image-ad-upload'].length && /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Crop Image",
        onClick: function onClick() {
          return _this.setState({
            showImageCropModal: true
          });
        }
      })) : dropzoneComponent({
        name: "".concat(key, "-ad-upload"),
        organization: _this.props.organization,
        multiple: multiple,
        video: video,
        onChange: function onChange(mediaArray) {
          _this.props.changeAdBuilderValue(_this.props.organization.id, _defineProperty({}, "".concat(key, "-ad-upload"), mediaArray));

          _this.throttleAdPreview(_this.props.adDetails);
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "updateParsedFields", function () {
      var orgId = _this.props.organization.id;
      var _this$props = _this.props,
          parsedLinkData = _this$props.parsedLinkData,
          formValues = _this$props.formValues;
      console.dir(parsedLinkData);

      if (!formValues.linkHeadline || !formValues.linkHeadline.length) {
        _this.props.changeAdBuilderValue(orgId, {
          linkHeadline: parsedLinkData.title
        });
      }

      if (!formValues.linkDescription || !formValues.linkDescription.length) {
        _this.props.changeAdBuilderValue(orgId, {
          linkDescription: parsedLinkData.description
        });
      }

      if ((!formValues.adImage || !formValues.adImage.length || formValues.adImage.length && formValues.adImage[0] === 'https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg') && parsedLinkData.imageUrl) {
        _this.props.changeAdBuilderValue(orgId, {
          adImage: [parsedLinkData.imageUrl]
        });
      }

      _this.throttleAdPreview(_this.props.adDetails);
    });

    _defineProperty(_assertThisInitialized(_this), "handleParseLink", function (e) {
      _this.props.parseLink(e.target.value, _this.props.organization.id).then(_this.updateParsedFields)["catch"](function (err) {
        console.error(err);

        _this.throttleAdPreview(_this.props.adDetails);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeaveCropper", function () {
      if (confirm('Your changes are not saved. Do you really want to leave?') == true) {
        _this.setState({
          showImageCropModal: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCropImage", function () {
      var orgId = _this.props.organization.id;

      var values = _this.refs.cropper.values();

      if (!_this.state.imageBeenCropped) {
        _this.setState({
          originalImage: _this.props.formValues['image-ad-upload'][0],
          imageBeenCropped: true
        });
      }

      var image = _this.refs.cropper.crop();

      _this.props.uploadBase64Image(image, orgId).then(function (imageSrc) {
        if (imageSrc && imageSrc.hasOwnProperty('fullyQualifiedUrl')) {
          _this.props.changeAdBuilderValue(orgId, {
            'image-ad-upload': [imageSrc.fullyQualifiedUrl]
          });
        } else {
          alert('There was a problem cropping your image. Please try again later.');
        }

        _this.setState({
          showImageCropModal: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getRandomNum", function () {
      return Math.random().toString().slice(2, 11);
    });

    _this.state = {
      imageBeenCropped: false,
      adPreviewTabs: [{
        title: 'Desktop',
        key: 'DESKTOP_FEED_STANDARD',
        icon: 'fa-facebook',
        selected: true
      }, {
        title: 'Mobile',
        key: 'MOBILE_FEED_STANDARD',
        icon: 'fa-facebook'
      }, {
        title: 'Right Hand',
        key: 'RIGHT_COLUMN_STANDARD',
        icon: 'fa-facebook'
      }],
      formatTabs: [{
        title: 'Image',
        key: 'image',
        group: 'format',
        selected: _this.props.formValues.adFormatTabKey === 'image'
      }, _props.type && ['leadGeneration'].indexOf(_props.type) === -1 ? {
        title: 'Video',
        key: 'video',
        group: 'format',
        selected: _this.props.formValues.adFormatTabKey === 'video'
      } : null, _props.type && ['leadGeneration'].indexOf(_props.type) === -1 && _this.props.isLikeableUser ? {
        title: 'Slideshow',
        key: 'carousel',
        group: 'format',
        selected: _this.props.formValues.adFormatTabKey === 'carousel'
      } : null].filter(function (t) {
        return t;
      }),
      formatType: 'image',
      selectedPreviewTab: 'DESKTOP_FEED_STANDARD',
      isCreating: false,
      fbAdPreviewRendering: false,
      showImageCropModal: false,
      imageHeight: 444,
      imageWidth: 1200,
      imageRatio: 1200 / 444
    };
    return _this;
  }

  _createClass(AdStep3, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.websocket.off('video_did_process');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.formValues || !this.props.adDetails) {
        // From JMW:
        // IMPORTANT
        // This needs to be here because there is a short delay in
        // switching routes from the tabs. This causes this render to be called
        // with the wrong organization id which makes the form values null.
        // Things freak out if this is not here.
        return /*#__PURE__*/React.createElement("div", null);
      }

      var _this$props2 = this.props,
          adDetails = _this$props2.adDetails,
          type = _this$props2.type,
          adTypeText = _this$props2.adTypeText;

      var isLinkAd = _.includes(['clicksToWebsite'], type);

      var isLeadAd = _.includes(['leadGeneration'], type);

      var showHeadlineField = _.includes(['clicksToWebsite', 'leadGeneration'], type);

      var showCTASelector = _.includes(['clicksToWebsite', 'leadGeneration'], type);

      var showLeadDescriptionField = _.includes(['leadGeneration'], type);

      var cropModalActions = this.props.uploadingBase64Image ? [/*#__PURE__*/React.createElement(GrayButton, {
        label: "Cancel",
        style: {
          marginRight: 24
        },
        onClick: function onClick() {
          return alert('We are cropping your image, hang tight for a moment.');
        }
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Crop",
        onClick: this.handleCropImage,
        disabled: this.props.uploadingBase64Image
      })] : [/*#__PURE__*/React.createElement(GrayButton, {
        label: "Cancel",
        style: {
          marginRight: 24
        },
        onClick: this.handleLeaveCropper
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Crop",
        onClick: this.handleCropImage,
        disabled: this.props.uploadingBase64Image
      })];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Ad Builder - Create Ad"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-6 ".concat(styles.colXS6),
        style: {
          borderRight: '1px solid #f1f1f1',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: adTypeText,
        secondary: "Creative",
        style: {
          marginBottom: 16
        }
      })), /*#__PURE__*/React.createElement(FormSection, {
        title: "Ad Format"
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: this.state.formatTabs,
        onChange: this.tabChange
      })), this.renderImageArea(this.props.formValues.adFormatTabKey), /*#__PURE__*/React.createElement(FormSection, {
        title: "Copy"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "description",
        type: "text",
        placeholder: "Text",
        label: "Text",
        className: "form-control",
        multiLine: true,
        value: this.props.formValues.description,
        onBlur: function onBlur(e) {
          _this2.throttleAdPreview(_this2.props.adDetails);
        },
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            description: e.target.value
          });
        }
      }), showLeadDescriptionField && /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "leadFormDescription",
        type: "text",
        label: "Description",
        placeholder: "Description",
        className: "form-control",
        value: this.props.formValues.leadFormDescription,
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            leadFormDescription: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          _this2.throttleAdPreview(_this2.props.adDetails);
        }
      }), isLeadAd && showHeadlineField && /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "linkHeadline",
        type: "text",
        label: "Headline",
        placeholder: "Headline",
        className: "form-control",
        value: this.props.formValues.linkHeadline,
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            linkHeadline: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          _this2.throttleAdPreview(_this2.props.adDetails);
        }
      })), showCTASelector ? /*#__PURE__*/React.createElement(FormSection, {
        title: "Call to Action",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(FacebookCTASelector, {
        name: "call_to_action",
        className: "form-control",
        adType: this.props.type,
        value: this.props.formValues.call_to_action,
        onChange: function onChange(val) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            call_to_action: val
          });

          setTimeout(function () {
            _this2.throttleAdPreview(_this2.props.adDetails);
          }, 300);
        }
      })) : '', isLinkAd && /*#__PURE__*/React.createElement(FormSection, {
        title: "Link"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "linkUrl",
        type: "text",
        label: "URL",
        placeholder: "URL",
        className: "form-control",
        onBlur: this.handleParseLink,
        value: this.props.formValues.linkUrl,
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            linkUrl: e.target.value
          });
        }
      }), /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "linkHeadline",
        type: "text",
        label: "Headline",
        placeholder: "Headline",
        className: "form-control",
        value: this.props.formValues.linkHeadline,
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            linkHeadline: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          _this2.throttleAdPreview(_this2.props.adDetails);
        }
      }), /*#__PURE__*/React.createElement(LLTextField, {
        style: {
          width: '100%'
        },
        name: "linkDescription",
        type: "text",
        label: "Description",
        placeholder: "Description",
        className: "form-control",
        value: this.props.formValues.linkDescription,
        onChange: function onChange(e) {
          _this2.props.changeAdBuilderValue(_this2.props.organization.id, {
            linkDescription: e.target.value
          });
        },
        onBlur: function onBlur(e) {
          _this2.throttleAdPreview(_this2.props.adDetails);
        }
      })), this.state.submitError ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.state.submitError) : null, this.props.saveError ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.props.saveError) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.step2Button)
      }, /*#__PURE__*/React.createElement(SecondaryButton, {
        disabled: this.props.isCreatingAd || !this.canContinue(),
        label: "Finish",
        onClick: this.props.onSubmit
      })), /*#__PURE__*/React.createElement(Link, {
        style: {
          marginRight: 24
        },
        className: "".concat(styles.grayButton, " ").concat(styles.step2Button),
        to: {
          pathname: "/org/".concat(this.props.organization.id, "/create-ad/2"),
          state: {
            modal: false
          }
        }
      }, /*#__PURE__*/React.createElement("span", null, "Back")))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-0 col-sm-6 ".concat(styles.colXS6),
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 140px)',
          overflow: 'hidden',
          overflowY: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 12
        }
      }, /*#__PURE__*/React.createElement(MiniTabBar, {
        style: {
          width: 532
        },
        items: this.state.adPreviewTabs,
        onTabClick: this.handlePreviewTabChange
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.iframeWrap
      }, this.props.fbAdPreviewError && !this.props.isUploadingFacebookVideo ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.props.fbAdPreviewError.toString()) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IframePreview, _extends({
        selectedPreviewTab: this.state.selectedPreviewTab,
        onLoad: function onLoad() {
          return _this2.setState({
            fbAdPreviewRendering: false
          });
        }
      }, this.props)), !this.props.isUploadingFacebookVideo && /*#__PURE__*/React.createElement(SecondaryButton, {
        onClick: function onClick() {
          return _this2.getFBAdPreview();
        },
        label: "Reload Preview"
      })), !adBlocker.isDetected() && this.props.loadingFBAdPreview || (this.state.fbAdPreviewRendering || this.props.isUploadingFacebookVideo) && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%',
          position: 'absolute',
          left: 0,
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.iframeCover
      }), this.props.isUploadingFacebookVideo && /*#__PURE__*/React.createElement("p", {
        style: {
          width: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          backgroundColor: 'white',
          textAlign: 'center',
          padding: 12
        }
      }, "Processing video... This may take a moment..."), /*#__PURE__*/React.createElement(LoaderBar, {
        style: {
          position: 'absolute',
          top: 0,
          left: 0
        }
      }))))))), /*#__PURE__*/React.createElement(Dialog, {
        title: "Crop Your Image",
        titleStyle: {
          color: this.props.theme.colors.primaryColor
        },
        actions: cropModalActions,
        autoScrollBodyContent: true,
        modal: true,
        open: this.state.showImageCropModal,
        onRequestClose: function onRequestClose() {
          return _this2.setState({
            showImageCropModal: false
          });
        },
        bodyStyle: {
          color: '#717171',
          lineHeight: '24px'
        }
      }, this.props.adDetails.hasOwnProperty('image-ad-upload') && this.props.adDetails['image-ad-upload'].length && /*#__PURE__*/React.createElement(Cropper, {
        style: {
          marginTop: 16
        },
        src: this.state.imageBeenCropped ? "".concat(this.state.originalImage, "?v=cropped_").concat(this.getRandomNum()) : "".concat(this.props.adDetails['image-ad-upload'][0], "?v=cropper_").concat(this.getRandomNum()),
        ref: "cropper",
        ratio: this.state.imageRatio
      })));
    }
  }]);

  return AdStep3;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired,
  adDetails: PropTypes.object,
  type: PropTypes.string
}), _defineProperty(_class2, "defaultProps", {
  type: 'pageLikes'
}), _temp)) || _class);
export default AdStep3;